import { RouteRecordRaw } from 'vue-router';

export const assetsRoutes: Record<string, RouteRecordRaw> = {
    redirect: {
        path: '',
        name: 'Storage Tracking Redirect',
        redirect: { name: 'storetrackOverview' },
        meta: {
            headName: 'Storage Tracking Redirect',
        },
    },
    overview: {
        path: 'overview',
        name: 'storetrackOverview',
        components: {
            default: () => import('@/views/storageTracking/OverviewView.vue'),
        },
        meta: {
            headName: 'Overview',
            pageNeedsLoader: true,
            accessName: 'assetTrackingOverview',
            searchMeta: {
                tags: ['battery', 'storage', 'BESS'],
            },
        },
    },
    marketTrends: {
        path: 'market-trends',
        name: 'marketTrends',
        components: {
            default: () => import('@/views/storageTracking/MarketTrendsView.vue'),
        },
        meta: {
            headName: 'Market Trends',
            pageNeedsLoader: true,
            accessName: 'marketTrends',
            searchMeta: {
                tags: ['battery', 'storage', 'BESS', 'rankings'],
            },
        },
    },
    rankings: {
        path: 'rankings',
        name: 'rankings',
        components: {
            default: () => import('@/views/storageTracking/RankingsView.vue'),
        },
        meta: {
            headName: 'Rankings',
            pageNeedsLoader: true,
            accessName: 'rankings',
            searchMeta: {
                tags: ['battery', 'storage', 'BESS', 'trends'],
            },
        },
    },
    companySearch: {
        path: 'company-search',
        name: 'companySearch',
        components: {
            default: () => import('@/views/storageTracking/CompanySearchView.vue'),
        },
        meta: {
            headName: 'Company Search',
            pageNeedsLoader: true,
            accessName: 'companySearch',
            searchMeta: {
                tags: ['battery', 'storage', 'BESS', 'owner', 'optimiser', 'financer', 'developer'],
            },
        },
    },
    projectSearch: {
        path: 'project-search',
        name: 'projectSearch',
        components: {
            default: () => import('@/views/storageTracking/ProjectSearchView.vue'),
        },
        meta: {
            headName: 'Project Search',
            pageNeedsLoader: true,
            accessName: 'projectSearch',
            searchMeta: {
                tags: ['battery', 'storage', 'BESS', 'asset'],
            },
        },
    },
    plantTable: {
        path: 'plant-table',
        name: 'plantTable',
        components: {
            default: () => import('@/views/powerMarkets/PlantTableView.vue'),
        },
        meta: {
            headName: 'Plant Table',
            accessName: 'plant-table',
            searchMeta: {
                tags: ['BMU', 'powerplant', 'asset'],
            },
        },
    },
    registers: {
        path: 'registers',
        name: 'registers',
        components: {
            default: () => import('@/views/powerMarkets/RegistersView.vue'),
        },
        meta: {
            headName: 'Registers',
            accessName: 'registers',
            searchMeta: {
                tags: ['BMU', 'powerplant', 'asset', 'embedded', 'transmission', 'distribution'],
            },
        },
    },
    customCharting: {
        path: 'custom-charting',
        name: 'customCharting',
        components: {
            default: () => import('@/views/storageTracking/CustomChartingView.vue'),
        },
        meta: {
            headName: 'Custom Charting',
            pageNeedsLoader: true,
            accessName: 'customCharting',
            searchMeta: {
                tags: ['battery', 'storage', 'BESS', 'asset'],
            },
        },
    },
    projectUpdates: {
        path: 'project-updates',
        name: 'projectUpdates',
        components: {
            default: () => import('@/views/storageTracking/ProjectUpdatesView.vue'),
        },
        meta: {
            headName: 'Project Updates',
            pageNeedsLoader: true,
            accessName: 'projectUpdates',
            searchMeta: {
                tags: ['battery', 'storage', 'BESS', 'asset', 'news'],
            },
        },
    },
};
